import React from 'react';
import Tippy from '@tippyjs/react';
import { Placement } from 'tippy.js';
import { appAssets } from 'constants/assets';
import './DataValidationTip.scss';

type ValidationKind = 'warning' | 'error';

interface DataValidationTipProps {
  /** Tooltip message to display. When undefined the component renders nothing. */
  message?: string;
  /** Icon colour variant (default: 'error') */
  kind?: ValidationKind;
  /** Tippy placement (default: 'top') */
  placement?: Placement;
}

/**
 * A validation message component that displays an alert icon with a tooltip.
 */
const DataValidationTip: React.FC<DataValidationTipProps> = ({
  message,
  kind = 'error',
  placement = 'top',
}) => {
  const SystemAlertIcon = appAssets.icons.SYSTEM_ALERT;

  if (!message) return null;

  const iconClassName = `enterprise-validation-message__icon enterprise-validation-message--${kind}`;

  return (
    <Tippy
      className="tooltip-container"
      placement={placement}
      content={
        <div>
          <div className="tooltip-text data-validation-tip__text">{message}</div>
        </div>
      }
    >
      <SystemAlertIcon className={iconClassName} />
    </Tippy>
  );
};

export default DataValidationTip;
